import classNames from "classnames";
import React, { HTMLAttributes } from "react";
import Color from "color";

export type BadgeVariant = "new" | "info";

export type BadgeMorph = "rounded" | "rounded-rectangular" | "pill" | "capsule" | "tag" | "ribbon";

export type BadgeProps = {
	shine?: boolean;
	disabled?: boolean;
	variant?: BadgeVariant;
	morph?: BadgeMorph;
	backgroundColor?: string;
	foregroundColor?: string;
	badgeRef?: React.Ref<HTMLDivElement>;
} & HTMLAttributes<HTMLSpanElement>;

export const Badge: React.FunctionComponent<BadgeProps> = ({
	children,
	shine = false,
	disabled = false,
	variant = "new",
	morph = "pill",
	backgroundColor,
	foregroundColor,
	style,
	badgeRef,
	className,
	...rest
}) => {
	const classes = classNames("badge", `badge__style-${variant}`, `badge__shape-${morph}`, {"badge__disabled": disabled}, className);

	const renderStyle: React.CSSProperties = { ...style };
	if (!disabled && backgroundColor) {
		renderStyle.backgroundColor = backgroundColor;
		renderStyle.borderColor = backgroundColor;

		if (foregroundColor) {
			renderStyle.color = foregroundColor;
		} else {
			renderStyle.color = Color(backgroundColor).isDark() ? "#ffffff" : "#111111";
		}
	}

	return (
		<div className={classes} ref={badgeRef} style={renderStyle} {...rest}>
			{shine && !disabled && <div className="badge__shine" />}
			<div className="badge__inner">{children}</div>
		</div>
	)
}